module.exports = __webpack_public_path__ + "static/media/Robert Green Headshot_1703003000047.cbd66d30.png";